<template>
  <router-link tag="section" :to="link" class="container-widget-circle d-flex flex-column align-items-center">
    <div class="circleimg">
      <div class="content-icon">
        <img :src="icon" :alt="titulo">
      </div>
      <img :src="bgImg" :alt="titulo">
    </div>
    <h3 class="text-white text-center md-headline mt-4">{{ titulo }}</h3>
  </router-link>
</template>

<script>
  export default {
    name: 'WidgetIconOnCircle',
    props: {
      titulo: { type: String, default: "Titulo" },
      icon: { default: require("../assets/icon/empty_512_gray.png") },
      bgImg: { default: require("../assets/background/bg_null.jpg") },
      link: { type: String, default: "" },
    }
  }
</script>

<style lang="scss" scoped>
  .container-widget-circle {
    cursor: pointer;
    &:hover .content-icon{
      background-color: rgba(0, 0, 0, 0.50);
    }
    &:active .content-icon{
      background-color: rgba(0, 0, 0, 0.40);
    }
  }

  .circleimg {
    display: flex;
    width: 300px;
    min-width: 300px;
    overflow: hidden;
    border-radius: 50%;
    height: 300px;
    position: relative;

    .content-icon {
      transition: 250ms;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.70);
      img { width: 60%; }
    }

    img { display: flex; }
  }


</style>
